import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.Weather`]: 'Weather',
      [`${prefix}.Preparation.MinimumAirTemperature`]: 'Minimum Air Temperature',
      [`${prefix}.Preparation.MaximumAirTemperature`]: 'Maximum Air Temperature',
      [`${prefix}.Preparation.LayerThickness`]: 'Layer Thickness',
      [`${prefix}.Preparation.LayerThicknessUnavailable`]: 'Data Not Supplied',
      [`${prefix}.Preparation.DepthOfTest`]: 'Depth Of Test',
      [`${prefix}.Preparation.DepthOfTestUnavailable`]: 'Data Not Supplied',
      [`${prefix}.Preparation.MaxRequiredPressure`]: 'Maximum Pressure to Be Applied',
      [`${prefix}.Preparation.IsExcavationTest`]: 'Test Carried out in Excavation',
      [`${prefix}.Preparation.SeatingLoad`]: 'Seating Load',
      [`${prefix}.Preparation.PlateEdgeToWallDistance`]: 'Distance From Edge of Plate to Wall',
      [`${prefix}.Preparation.CombinedEquipmentLoad`]: 'Combined Equipment Load',
      [`${prefix}.Preparation.AdditionalEquipmentMass`]: 'Combined Mass of Additional Equipment',
      [`${prefix}.Preparation.ApplyEquipmentLoadToReadings`]: 'Apply Equipment Load to Readings',
      [`${prefix}.Preparation.PlateBeddingMaterial`]: 'Plate Bedding Material',
      [`${prefix}.Preparation.ReactionLoad`]: 'Reaction Load/Kentledge',

      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.Equipment.LoadCell`]: 'Load Cell',
      [`${prefix}.Equipment.LoadCell.Results.LoadCellFactor`]: 'Factor',
      [`${prefix}.Equipment.LoadCell.Results.Readability`]: 'Readable To Nearest',
      [`${prefix}.Equipment.LoadCellFactor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGauge1`]: 'Displacement Gauge 1',
      [`${prefix}.Equipment.DisplacementGauge2`]: 'Displacement Gauge 2',
      [`${prefix}.Equipment.DisplacementGauge3`]: 'Displacement Gauge 3',
      [`${prefix}.Equipment.DisplacementGauge1.Results.Readability`]: 'Readability',
      [`${prefix}.Equipment.DisplacementGauge2.Results.Readability`]: 'Readability',
      [`${prefix}.Equipment.DisplacementGauge3.Results.Readability`]: 'Readability',
      [`${prefix}.Equipment.DisplacementGauge1.Results.Factor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGauge2.Results.Factor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGauge3.Results.Factor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGauge1Factor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGauge2Factor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGauge3Factor`]: 'Factor',
      [`${prefix}.Equipment.DisplacementGaugeOrientation`]: 'Displacement Readings (As Settlement Increases)',
      [`${prefix}.Equipment.UseAdditionalPlate`]: 'Use Additional Plate',
      [`${prefix}.Equipment.OffsetIncrementReadingsByInitialSeating`]: 'Offset Load Increment Readings by Initial Readings',
      [`${prefix}.Equipment.Plate1.Plate`]: 'Plate',
      [`${prefix}.Equipment.Plate2.Plate`]: 'Plate',
      [`${prefix}.Equipment.Plate1.Diameter`]: 'Diameter',
      [`${prefix}.Equipment.Plate2.Diameter`]: 'Diameter',
      [`${prefix}.Equipment.Plate1.Area`]: 'Area',
      [`${prefix}.Equipment.Plate2.Area`]: 'Area',
      [`${prefix}.Equipment.Plate1.Mass`]: 'Mass',
      [`${prefix}.Equipment.Plate2.Mass`]: 'Mass',
      [`${prefix}.Equipment.CylinderJack`]: 'Jack',
      [`${prefix}.Equipment.CylinderJackMass`]: 'Mass',
      [`${prefix}.Equipment.Timer`]: 'Timer',
      [`${prefix}.Equipment.Thermometer`]: 'Thermometer',

      [`${prefix}.LoadIncrements.DesiredLoad`]: 'Desired Load',
      [`${prefix}.LoadIncrements.DesiredLoadInDivisions`]: 'Desired Load',
      [`${prefix}.LoadIncrements.IncrementLoad`]: 'Increment Load',
      [`${prefix}.LoadIncrements.IncrementLoadInDivisions`]: 'Increment Load',
      [`${prefix}.LoadIncrements.DesiredPressure`]: 'Desired Pressure',
      [`${prefix}.LoadIncrements.IncrementPressure`]: 'Increment Pressure',

      [`${prefix}.Results.MaximumAppliedPressure`]: 'Maximum Applied Pressure',
      [`${prefix}.Results.MoistureContent`]: 'Moisture Content',
      [`${prefix}.Results.Cycles.MaximumDeformation`]: 'Maximum Deformation',
      [`${prefix}.Results.Cycles.CalculateEquivalentCBR`]: 'Calculate Equivalent CBR Results',
      [`${prefix}.Results.Cycles.PressureCBRSettlement`]: 'Pressure at 1.25 mm Settlement',
      [`${prefix}.Results.Cycles.EquivalentCBR`]: 'Equivalent CBR',
      [`${prefix}.Results.Cycles.ModulusOfSubgradeReaction`]: 'Modulus of Subgrade Reaction',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Equipment.LoadCell.Results.Readability`]: 'divs',
      [`${prefix}.Equipment.LoadCell.Results.LoadCellFactor`]: 'kN/div',
      [`${prefix}.Equipment.LoadCellFactor`]: 'kN/div',
      [`${prefix}.Equipment.DisplacementGauge1.Results.Readability`]: 'divs',
      [`${prefix}.Equipment.DisplacementGauge2.Results.Readability`]: 'divs',
      [`${prefix}.Equipment.DisplacementGauge3.Results.Readability`]: 'divs',
      [`${prefix}.Equipment.DisplacementGauge1Factor`]: 'mm/div',
      [`${prefix}.Equipment.DisplacementGauge2Factor`]: 'mm/div',
      [`${prefix}.Equipment.DisplacementGauge3Factor`]: 'mm/div',
      [`${prefix}.Equipment.DisplacementGauge1.Results.Factor`]: 'mm/div',
      [`${prefix}.Equipment.DisplacementGauge2.Results.Factor`]: 'mm/div',
      [`${prefix}.Equipment.DisplacementGauge3.Results.Factor`]: 'mm/div',

      [`${prefix}.LoadIncrements.DesiredLoadInDivisions`]: 'divs',
      [`${prefix}.LoadIncrements.IncrementLoadInDivisions`]: 'divs',

      [`${prefix}.Results.MoistureContent`]: '%',
      [`${prefix}.Results.Cycles.EquivalentCBR`]: '%',
      [`${prefix}.Results.Cycles.ModulusOfSubgradeReaction`]: 'MN/m²/m',
    })
  );

export default getLabelConfig;
